import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import handle401 from '../handle-401';
import HttpClient from '../../Api/HttpClient';

const userListQuery = ({ type = 'internal', companyId } = {}) =>
  queryOptions({
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    queryKey: ['user-list', type, companyId],
    queryFn: handle401(async () => {
      const payload = {};
      if (type === 'internal') {
        payload.onlyStaff = true;
      } else if (type === 'external') {
        payload.usersByCompany = true;
        payload.company_id = companyId;
      }

      const { data } = await HttpClient.fetchAllUsers(payload);

      return data.map((user) => ({
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
        avatarUrl: user.avatar,
        role: user.role,
      }));
    }),
  });

export default userListQuery;
